/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Password_WrongInputs */



/**
* | output |
* | --- |
* | "That email and password do not match. Try again, or send yourself a sign-in link." |
*
* @param {Signin_Password_WrongInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const signin_password_wrong = /** @type {((inputs?: Signin_Password_WrongInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Password_WrongInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("That email and password do not match. Try again, or send yourself a sign-in link.")
});